import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <g transform="translate(11.000000, 25.000000)">
          <path
            d="M 6.006 35.229 L 6.006 11.67 L 6.421 11.67 L 18.555 35.229 L 24.707 35.229 L 24.707 0 L 18.701 0 L 18.701 23.413 L 18.286 23.413 L 6.177 0 L 0 0 L 0 35.229 L 6.006 35.229 Z M 38.257 35.229 L 38.257 24.512 L 41.357 20.557 L 50.977 35.229 L 59.058 35.229 L 46.143 15.552 L 58.276 0 L 50.952 0 L 38.623 16.04 L 38.257 16.04 L 38.257 0 L 31.665 0 L 31.665 35.229 L 38.257 35.229 Z"
            fill="currentColor"
          />
        </g>
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
